import { useUrlFilters } from "../../../../../../context/selectedFilters";
import { buildFilterParams } from "../helpers";

export const useFilterParams = (): string[] => {
  const urlFilters = useUrlFilters();
  return buildFilterParams(urlFilters);
};
